import axios from 'axios';
import { Auth } from 'aws-amplify';
import { EXPIRED } from '../auth/actions';

import Config from '../../config';

import { BP_ASSETS_GET } from './actions';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';

const api_get_bundles = (data) => {
    return (dispatch, getState) => {


        Auth.currentSession().then((session) => {

            const token = session && session.idToken.jwtToken;

            var config = { headers: { Authorization: 'Bearer ' + token } };

            var queryString = Object.keys(data).map(key => key + '=' + data[key]).join('&');

            return axios.get(`${Config.API_BASE_URL}/bp/assets?${queryString}`, config)
                .then(response => {
                    dispatch({
                        type: BP_ASSETS_GET,
                        payload: {
                            ...response.data,
                            errors: {},
                            task: {
                                result: true
                            }
                        }
                    });
                })
                .catch(error => {
                    dispatch({
                        type: BP_ASSETS_GET,
                        payload: {
                            errors: {},
                            task: {
                                result: false
                            }
                        }
                    })
                });

        }).catch(error => {
            dispatch({ type: EXPIRED });
        });
    };
}

export default api_get_bundles;